// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  margin: 15px;
}

.user-header {
  background: #ffffff;
  margin-bottom: 5px;
  border-bottom: 1px solid black;
  width: 100%;

  h1 {
    font-size: 20px;
    font-weight: 500;
    margin: 0;
    color: #181818;
    text-align: left;
    width: 100%;
  }
}

.text-input-container {
  margin-bottom: 15px;
}

.form-label {
  display: block;
  margin-bottom: 5px;
}

.validation {
  color: red;
  font-size: 12px;
}

.note {
  font-weight: 700;
  font-size: 0.8125rem;
  word-wrap: break-word;
}

.dropdown-select {
  width: 98.8%;
}
`, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-user/new-user/ert-new-user/ert-new-user.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;;EAEX;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".form {\n  margin: 15px;\n}\n\n.user-header {\n  background: #ffffff;\n  margin-bottom: 5px;\n  border-bottom: 1px solid black;\n  width: 100%;\n\n  h1 {\n    font-size: 20px;\n    font-weight: 500;\n    margin: 0;\n    color: #181818;\n    text-align: left;\n    width: 100%;\n  }\n}\n\n.text-input-container {\n  margin-bottom: 15px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.validation {\n  color: red;\n  font-size: 12px;\n}\n\n.note {\n  font-weight: 700;\n  font-size: 0.8125rem;\n  word-wrap: break-word;\n}\n\n.dropdown-select {\n  width: 98.8%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
